function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.46063 13.6026C9.27063 13.7926 9.01962 13.8986 8.75061 13.8986C8.48062 13.8986 8.23062 13.7926 8.03662 13.6026L2.38562 7.95163C2.21463 7.77661 2.12061 7.54962 2.12061 7.30664C2.12061 7.06363 2.21463 6.83163 2.38562 6.66162L4.01361 5.03363C4.18463 4.86264 4.41263 4.76764 4.65561 4.76764C4.90262 4.76764 5.12961 4.86264 5.30063 5.03363L8.75061 8.48264L13.8856 3.35162C12.5006 1.84863 10.5156 0.911621 8.31363 0.911621C4.12061 0.911621 0.723633 4.30862 0.723633 8.50162C0.723633 12.6916 4.12061 16.0886 8.31363 16.0886C12.5036 16.0886 15.9006 12.6916 15.9006 8.50162C15.9006 8.08063 15.8666 7.66663 15.7986 7.26862L9.46063 13.6026Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.186 3.45758L16.691 1.96658C16.63 1.90561 16.546 1.87158 16.463 1.87158C16.379 1.87158 16.3 1.90561 16.235 1.96658L8.75098 9.45059L4.81901 5.51859C4.77299 5.4736 4.71699 5.45059 4.65598 5.45059C4.59901 5.45059 4.542 5.4736 4.49598 5.51859L2.86799 7.14359C2.78098 7.23459 2.78098 7.3786 2.86799 7.46561L8.52299 13.1206C8.58399 13.1816 8.667 13.2156 8.75098 13.2156C8.83399 13.2156 8.91398 13.1816 8.97898 13.1206L15.624 6.47559L18.186 3.9176C18.311 3.7886 18.311 3.58759 18.186 3.45758Z",
  fill: "currentColor"
});

var SvgCompleteTick = function SvgCompleteTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompleteTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/completeTick.baa17eac.svg";
export { ForwardRef as ReactComponent };